import { render, staticRenderFns } from "./DropdownFilters.vue?vue&type=template&id=2f6d538d&scoped=true"
import script from "./DropdownFilters.vue?vue&type=script&lang=js"
export * from "./DropdownFilters.vue?vue&type=script&lang=js"
import style0 from "./DropdownFilters.vue?vue&type=style&index=0&id=2f6d538d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d538d",
  null
  
)

export default component.exports